/** 县区登记册导出页面（规划第三阶段 P3-6a）：已承诺土地用途图层，每个县区一个文件。 */
export default {
  registerExport: {
    navLabel: '县区导出',
    title: '县区登记册导出',
    subtitle: '提交给 PLANMalaysia 的已承诺土地用途图层（K 图层），每个县区一个文件。',
    notPermitted: '只有管理员或审批人可以导出登记册。',
    unavailable: '县区导出随 KM 程序开放，目前尚不可用。',
    area: '县区',
    areaPlaceholder: '选择县区',
    sequence: '序号',
    sequenceHint: '建议：{{proposed}}。可填 01 至 99 的任何数字；重复使用较早的数字不会改变建议。',
    sequenceInvalid: '请输入 1 至 99 的数字。',
    fileName: '文件名：{{name}}',
    periodFrom: '批准起始日期',
    periodTo: '批准截止日期',
    periodHint: '两个日期都留空即导出所有有效的许可。',
    submit: '导出',
    submitting: '正在排队…',
    queued: '导出已排队，通常需要几分钟。',
    recent: '最近的导出',
    none: '尚无导出。',
    download: '下载',
    downloading: '正在准备…',
    showReport: '显示报告',
    hideReport: '隐藏报告',
    reportTitle: '验证报告',
    passed: '通过',
    notPassed: '未通过',
    counts: '来自 {{cases}} 份提交的 {{rows}} 行',
    rate: '{{name}}：{{rate}}',
    limit: '上限 {{limit}}',
    overlap: '重叠',
    gap: '空隙',
    failuresTitle: '发送前必须修正',
    warningsTitle: '需要检查',
    cases: '提交：{{refs}}',
    fields: '字段：{{fields}}',
    columns: {
      file: '文件',
      area: '县区',
      status: '状态',
      rows: '行数',
      size: '大小',
      requested: '请求时间',
      actions: '操作',
    },
    status: { queued: '排队中', running: '生成中', done: '已就绪', failed: '失败' },
    errorCodes: {
      REGISTER_EXPORT_FAILED: '导出失败。请重试；如再次失败，请联系支持。',
      REGISTER_EXPORT_EMPTY: '该县区没有可导出的有效许可。',
      REGISTER_EXPORT_TOO_LARGE: '文件太大，无法发送。',
      REGISTER_EXPORT_STALE: '导出在完成前停止了，请重新开始。',
    },
    failures: {
      no_rows: '没有导出任何行。',
      overlap_rate: '地块重叠超出允许的上限。',
      gap_rate: '地块未覆盖的场地面积超出上限。',
      empty_attributes: '部分行的必填字段为空。',
      truncated: '部分值超出其字段长度。',
      gtn_paths: '部分行的土地用途类别路径不在官方列表中。',
      lot_duplicates: '同一个地段号出现在同一 mukim 的多份提交中。',
      refused_rows: '部分行使用 Kertau 基准绘制，已被排除。',
    },
    warnings: {
      without_upi: '部分行没有 UPI。',
      missing_area: '部分有效许可未注明县区，未被导出。',
      legacy_without_decision_number: '决定编号启用前的批准没有证书号。',
      imported_without_rows: '从其他系统导入的已批准提交在此没有行。',
      local_without_rows: '该县区部分已批准的提交没有导出的行。',
    },
    tiers: {
      title: '土地用途类别（第 2 和第 3 级）',
      intro: '以 JSON 文件导入官方第 2 和第 3 级类别。导出会写入其文字和代码。',
      count: '已导入 {{count}} 个类别',
      none: '尚未导入第 2 或第 3 级类别。',
      import: '导入 JSON',
      download: '下载 JSON',
      clear: '全部删除',
      save: '保存类别',
      saving: '正在保存…',
      saved: '类别已保存。',
      cancel: '取消',
      pending: '{{count}} 个类别待保存',
      invalid: {
        json: '该文件不是有效的 JSON。',
        shape: '第 {{position}} 项不是有效的类别（代码、上级、第 2 或 3 级、官方文字、最多 7 个大写字符的代码）。',
        too_many: '一个文件最多可包含 600 个类别。',
        duplicate: '第 {{position}} 项重复了类别代码。',
      },
    },
  },
  errors: {
    invalid_register_export: '导出参数无效。',
    register_export_unavailable: '县区导出随 KM 程序开放，目前尚不可用。',
    register_export_not_found: '未找到该导出。',
    register_export_not_ready: '该导出尚未就绪。',
    too_many_register_exports: '已有一个导出正在生成，请等待其完成。',
  },
} as const
